export default __webpack_public_path__ + "static/Rubik-Regular-b70a79b74e55d10da070a387e77ead38.ttf";